/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { underwritingGet } from "../../funcs/underwritingGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetUnderwritingRequest$inboundSchema,
};

export const tool$underwritingGet: ToolDefinition<typeof args> = {
  name: "underwriting-get",
  description: `Retrieve underwriting associated with a given Moov account. 

Read our [underwriting guide](https://docs.moov.io/guides/accounts/requirements/underwriting/) to learn more. 

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/profile.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await underwritingGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
